/**
 * @generated SignedSource<<cc76c0ca3a1a5bcf794a45a053e57b37>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespQuickFilters_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilterDropdown_user">;
  readonly " $fragmentType": "SbRespQuickFilters_user";
};
export type SbRespQuickFilters_user$key = {
  readonly " $data"?: SbRespQuickFilters_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilters_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespQuickFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespQuickFilterDropdown_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "abda078621566ef0938dd06886ffed5e";

export default node;
